import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default (config) => ({
    swiper: null,
    label: config.label || '',
    currency: config.currency || 'EUR',
    listId: config.listId || 'featured-category-carousel',

    init() {
        this.$nextTick(() => {
            this.initSwiper();
        });
    },

    initSwiper() {
        this.swiper = new Swiper(this.$refs.featuredCarousel, {
            modules: [Navigation],
            slidesPerView: 2.25,
            spaceBetween: 9.375,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                    spaceBetween: 9.375,
                },
                768: {
                    slidesPerView: 2.75,
                    spaceBetween: 9.375,
                },
                1024: {
                    slidesPerView: 2.25,
                    spaceBetween: 9.375,
                },
                1280: {
                    slidesPerView: 3.25,
                    spaceBetween: 9.375,
                },
            },
            on: {
                init: () => {
                    this.sendImpressionEvent();
                },
            },
        });
    },

    sendImpressionEvent() {
        if (typeof gtag === 'undefined' || typeof dataLayer === 'undefined') {
            return;
        }

        const items = [];
        const slides = this.$refs.featuredCarousel.querySelectorAll('.swiper-slide');

        slides.forEach((slide, index) => {
            const itemId = slide.dataset.itemId;
            const itemName = slide.dataset.itemName;

            if (itemId && itemName) {
                items.push({
                    item_id: itemId,
                    item_name: itemName,
                    item_list_id: this.listId,
                    item_list_name: this.label,
                    index: index,
                });
            }
        });

        if (items.length > 0) {
            gtag('event', 'view_item_list', {
                item_list_id: this.listId,
                item_list_name: this.label,
                items: items,
            });
        }
    },

    onItemClick(event) {
        const link = event.target.closest('a[href*="/products/"]');
        if (!link) return;

        const slide = link.closest('.swiper-slide');
        if (!slide) return;

        const itemId = slide.dataset.itemId;
        const itemName = slide.dataset.itemName;
        const index = Array.from(slide.parentNode.children).indexOf(slide);

        if (typeof gtag !== 'undefined' && itemId && itemName) {
            gtag('event', 'select_item', {
                item_list_id: this.listId,
                item_list_name: this.label,
                items: [{
                    item_id: itemId,
                    item_name: itemName,
                    item_list_id: this.listId,
                    item_list_name: this.label,
                    index: index,
                }, ],
            });
        }
    },

    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    },
});
